enum InvestorIncomeTrustDivestmentRequestStatusEnum {
    Cancelled = 'CANCELLED',
    Pending = 'PENDING',
    Processed = 'PROCESSED',
}

export default InvestorIncomeTrustDivestmentRequestStatusEnum;
